import { action, payload } from 'ts-action'
import { IShift } from 'models/Shift'
import { IError, IPayload } from 'models/Global'

export const UpshifterRecommendedShiftsFetching = action(
  'UpshifterRecommendedShiftsFetching',
  payload<boolean>(),
)

export const GetUpshifterRecommendedShifts = action(
  'GetUpshifterRecommendedShifts',
  payload<IPayload<IShift[]>>(),
)

export const GetUpshifterRecommendedShiftsWithoutConcat = action(
  'GetUpshifterRecommendedShiftsWithoutConcat',
  payload<IPayload<IShift[]>>(),
)

export const GetUpshifterRecommendedShiftsErrors = action(
  'GetUpshifterRecommendedShiftsErrors',
  payload<IError>(),
)

export const ClearUpshifterRecommendedShiftsReducer = action(
  'ClearUpshifterRecommendedShiftsReducer',
)

export const UpshifterRecommendedShiftsSetHasMore = action(
  'UpshifterRecommendedShiftsSetHasMore',
  payload<boolean>(),
)
